import React, { useContext } from 'react'
import { Container } from '@mui/system'
import { Divider, Typography } from '@mui/material'

//components
import GameCard from './components/GameCard'
import EarnGiftCards from 'components/EarnGiftCards'
import GenericUnlockGmailRewardsTask from 'components/Task/GenericUnlockGmailRewardsTask'
//contexts
import AuthContext from 'context/AuthContext'

const Content = ({ gameLibrary }: any) => {
  const { user } = useContext(AuthContext)

  return (
    <Container maxWidth="sm">
      <Typography variant="h1">Favorite Games</Typography>
      <Typography variant="h4" sx={styles.text}>
        Explore all of the games that you’ve earned rewards for!
      </Typography>
      <div>
        {!gameLibrary?.length && (
          <div className="gameLibraryDescription">
            <Typography variant="inherit">No rewards earned yet...</Typography>
            <EarnGiftCards />
            {!user?.hasParsingEnabled && (
              <span>
                <br />
                <Divider variant="fullWidth" />
                <br />
                <GenericUnlockGmailRewardsTask />
              </span>
            )}
          </div>
        )}
        <div className="gameLibraryItems">
          {gameLibrary?.map(
            (game: any) => game.gameDetails && <GameCard key={game.unifiedAppId} game={game} />
          )}
        </div>
      </div>
    </Container>
  )
}

const styles = {
  text: {
    fontWeight: 400,
    marginTop: '8px',
  },
  button: {
    padding: '16px',
    marginTop: '20px',
  },
}

export default Content
